var map = {
	"./basketball-active.webp": 1541,
	"./basketball.webp": 1542,
	"./bg.webp": 1543,
	"./football-active.webp": 1544,
	"./football.webp": 1545,
	"./games-active.webp": 1546,
	"./games.webp": 1547,
	"./live-streaming-cover.webp": 1548,
	"./lv-active-bg.webp": 1549,
	"./video-bg.webp": 1550,
	"./video-icon.webp": 1551,
	"./vs.webp": 1552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;